import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ToastService } from "@app/services";
import { selectAttachmentsCanActivate } from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AttachmentGuard implements CanActivate {
  constructor(private store: Store, private toastService: ToastService) {}

  waitForAttachmentsToLoad(): Observable<boolean> {
    return this.store.select(selectAttachmentsCanActivate).pipe(
      tap(
        (canActivate) =>
          !canActivate && this.toastService.show("Attachments loading...")
      ),
      filter((canActivate) => canActivate),
      take(1)
    );
  }

  canActivate(): Observable<boolean> {
    return this.waitForAttachmentsToLoad();
  }
}
